import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ui } from '@procuros/datachecks';

import { useErrorContext } from 'contexts/ErrorsNavigationContext/ErrorsNavigationContext';
import { WebEDIError } from 'services/webediErrors/types';
import { DisplayModes } from 'components/DataTable/Types';
import { DataDisplay } from 'components/Form/DataDisplay/DataDisplay';
import { SchemableFormInput } from 'components/Form/SchemableFormInput/SchemableFormInput';
import { useFieldState } from 'components/SchemableForm/hooks/useFieldState';
import { Translate } from 'components/Translate/Translate';

type BooleanFieldProps = {
  field: ui.BooleanField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};
export const BooleanField = ({ field, fieldId, isReadOnly, mode, variant }: BooleanFieldProps) => {
  const { t } = useTranslation();
  const value = useWatch({ name: fieldId });
  const { register } = useFormContext();
  const { service } = useErrorContext<WebEDIError>();
  const error = service.useErrorById(fieldId);
  const numberOfErrors = service.useNumberOfActiveErrors();
  const fieldState = useFieldState(fieldId, error);

  const setCurrentError = service.setCurrentError;

  if (mode === DisplayModes.view) {
    return (
      <DataDisplay
        value={value ? t('common:yes') : t('common:no')}
        label={field.label}
        totalNumberOfErrors={numberOfErrors}
        error={error}
        fieldId={fieldId}
        onShowFieldErrorModal={() => error && setCurrentError(error)}
        description={field.description}
      />
    );
  }
  return (
    <SchemableFormInput
      type="checkbox"
      label={field.label}
      description={field.description ? <Translate i18nKey={field.description} /> : undefined}
      error={error}
      totalNumberOfErrors={numberOfErrors}
      {...register(fieldId)}
      value={value}
      onShowFieldErrorModal={() => error && setCurrentError(error)}
      required={field.modality === 'MANDATORY'}
      disabled={isReadOnly}
      variant={variant}
      valueDescription={field.value_description}
      className={'!size-4'}
      fieldState={fieldState}
    />
  );
};
